import React, { useEffect, useRef } from "react";
import { KLineChartPro } from "@klinecharts/pro";
import "@klinecharts/pro/dist/klinecharts-pro.css";
import { useCompanyHistoricalData } from "data/company";


export default function KLineChartProC({ companyinfo }) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);
 const { historicaldata, isLoading } =
    useCompanyHistoricalData(companyinfo?.id);
    
  useEffect(() => {
    if (!containerRef.current) return;
    if (isLoading) return;
    if (!historicaldata) return;

    const rawData = historicaldata || [];

    if (
      !Array.isArray(rawData) ||
      rawData.length === 0
    ) {
      return;
    }

    const formatted = rawData
  .sort(
    (a, b) =>
      new Date(a.trade_date) -
      new Date(b.trade_date)
  )
  .map(item => ({
    timestamp: Number(
      new Date(item.trade_date).getTime()
    ),

    open: Number(item.open_price),

    high: Number(item.high_price),

    low: Number(item.low_price),

    close: Number(item.close_price),

    volume: Number(item.volume)
  }))
  .filter(
    item =>
      !isNaN(item.timestamp) &&
      !isNaN(item.open) &&
      !isNaN(item.high) &&
      !isNaN(item.low) &&
      !isNaN(item.close) &&
      !isNaN(item.volume)
  );

    chartRef.current = new KLineChartPro({
      container: containerRef.current,
      drawingBarVisible: true,
    
      locale: "en-US",

      theme: "light",

      timezone: "Asia/Kolkata",

      symbol: {
        ticker: companyinfo?.symbol,
        shortName: companyinfo?.symbol,
        exchange: "NSE",
        market: "stocks",
        priceCurrency: "INR",
        type: "stock",
        name: companyinfo?.symbol,
      },

      period: {
        multiplier: 1,
        timespan: "day",
        text: "1D"
      },

      periods: [
        {
          multiplier: 1,
          timespan: "minute",
          text: "1m"
        },
        {
          multiplier: 5,
          timespan: "minute",
          text: "5m"
        },
        {
          multiplier: 15,
          timespan: "minute",
          text: "15m"
        },
        {
          multiplier: 1,
          timespan: "day",
          text: "1D"
        }
      ],

      mainIndicators: ["MA",],

      subIndicators: ["VOL", "RSI"],

      datafeed: {
        searchSymbols: async () => [],
getHistoryKLineData: async (
  symbol,
  period,
  from,
  to
) => {

   return formatted;
},

        subscribe: () => {},

        unsubscribe: () => {}
      }
    });
setTimeout(() => {
  chartRef.current?.setSymbol({
    ticker: companyinfo?.symbol,
    shortName: companyinfo?.symbol,
    exchange: "NSE",
    market: "stocks",
    priceCurrency: "INR",
    type: "stock",
    name: companyinfo?.symbol,
  });
}, 0);
    return () => {
      chartRef.current?.dispose?.();
    };
  }, [historicaldata, isLoading]);



  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "700px"
      }}
    />
  );
}